import { APIData } from './APIData';
import { api_data_topic_id } from '../../pages/api/persistent/topic/[...id]';
import { api_data_path_id } from '../../pages/api/persistent/path/[...id]';
import { api_data_bundle_id } from '../../pages/api/persistent/bundle/[id]';
import { api_data_question_id } from '../../pages/api/persistent/question/[id]';
import { runtime, Runtime } from '../runtime/Runtime';
import { AnyPersistentEntity } from '../../types/types_actors';

export class Persistent {
  readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  get runtime() {
    return this.parent;
  }

  readonly handlerCache = new Map<string, APIData<any>>();
  readonly entityCache = new Map<string, AnyPersistentEntity>(); // replace by LRU Cache?

  get edition(): number {
    // @ts-ignore
    if (typeof window !== 'undefined' && window.edition) return window.edition;
    return new Date().getTime();
  }

  route(type, id): string {
    return `/api/serialized/${type}/${id}?v=${this.edition}`;
  }

  entityData(type, id) {
    const cacheKey = `${type}_${id}`;
    if (this.handlerCache.has(cacheKey)) return this.handlerCache.get(cacheKey);
    const handler = new APIData({
      route: this.route(type, id),
      defaultValue: undefined,
    });
    this.handlerCache.set(cacheKey, handler);
    return handler;
  }

  topicData(id: number | string) {
    return this.entityData('topic', id) as APIData<typeof api_data_topic_id>;
  }

  pathData(id: number | string) {
    return this.entityData('path', id) as APIData<typeof api_data_path_id>;
  }

  bundleData(id: string) {
    return this.entityData('bundle', id) as APIData<typeof api_data_bundle_id>;
  }

  questionData(id: number) {
    return this.entityData('question', id) as APIData<typeof api_data_question_id>;
  }
}
